export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10676.d45d3da8.jpg";